module.exports = __webpack_public_path__ + "img/pic3.616d232a.png";